import script from "./Upload.vue?vue&type=script&setup=true&lang=js"
export * from "./Upload.vue?vue&type=script&setup=true&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=61e83ee2&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e83ee2"]])

export default __exports__